export const getCalendlyDeepLink = (): string => {
    return 'https://calendly.com/yasoft/15min?name=Jose&email=mar@test.com&a1=test';
};
